import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useDashboardStore } from 'src/feature/dashboard/store/dashboard.store'
import { useLocalizationStore } from 'src/feature/localization/store/localization.store'
import { PageMetrics } from 'src/feature/my-team/component/molecules/PageMetrics'
import { Palette } from 'src/feature/theme/model/Palette'

export type UserLearningMetricsProps = {
  userId: string
  isSidePanel: boolean
}

export const UserLearningMetrics = observer(({ userId, isSidePanel }: UserLearningMetricsProps) => {
  const dashboardStore = useDashboardStore()
  const { translation } = useLocalizationStore()
  const { isLoading } = dashboardStore.getGenericFieldsState('getUserDashboard')

  const pageTranslation = translation.pages.myTeam

  useEffect(() => {
    dashboardStore.getUserDashboard(userId)
  }, [dashboardStore, userId])

  const skillGapMetrics = [
    {
      label: pageTranslation.metricsHeader.highestRated(),
      value: dashboardStore.userDashboard?.highestRatedSkill || '-',
      icon: 'ArrowUpwardRoundedIcon',
      iconColor: Palette.OLIVE_GREEN,
    },
    {
      label: pageTranslation.metricsHeader.lowestRated(),
      value: dashboardStore.userDashboard?.lowestRatedSkill || '-',
      icon: 'ArrowDownwardRoundedIcon',
      iconColor: Palette.DANGER,
    },
    {
      label: pageTranslation.metricsHeader.avgSkillRating(),
      value: dashboardStore.userDashboard?.avgSkillRating || '-',
    },
    {
      label: pageTranslation.metricsHeader.avgExpectedRating(),
      value: dashboardStore.userDashboard?.avgExpectedSkillRating || '-',
    },
    {
      label: pageTranslation.metricsHeader.validated(),
      value: dashboardStore.userDashboard?.validated || '-',
    },
    {
      label: pageTranslation.metricsHeader.nonValidated(),
      value: dashboardStore.userDashboard?.nonValidated || '-',
    },
    {
      label: pageTranslation.metricsHeader.meetExpectation(),
      value: dashboardStore.userDashboard?.meetExpectation || '-',
    },
    {
      label: pageTranslation.metricsHeader.exceedExpectation(),
      value: dashboardStore.userDashboard?.exceedExpectation || '-',
    },
  ]

  return (
    <Box sx={styles.root}>
      <PageMetrics
        sx={{
          width: 'auto',
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: `repeat(${isSidePanel ? 4 : 8}, 1fr)` },
          gap: 10,
        }}
        metrics={skillGapMetrics}
        isLoading={isLoading}
        backgroundColor={'background.paper'}
      />
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 15,
  },
}
